import { Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import _ from "lodash";
import { BehaviorSubject, Subject } from "rxjs";
import { filter, takeUntil, tap } from "rxjs";

interface BreadcrumbInterface {
  level: number;
  module: string;
  name: string;
  params: any;
  parent: string;
  path: string;
  [prop: string]: any;
}

type Breadcrumb = Partial<BreadcrumbInterface>;

/**
 * @deprecated
 * 该服务过于复杂，将来由breadcrumb.service.ts替代
 */
@Injectable({
  providedIn: "root",
})
export class RouterService {
  private navigationEnd$ = new Subject<void>();

  get onNavigationEnd() {
    return this.navigationEnd$.asObservable();
  }

  private destroy$ = new Subject();

  constructor(private router: Router) {
    // this.breadcrumb$.subscribe();
    this.initRouterEvents();
  }

  initRouterEvents() {
    this.destroy$ = new Subject();

    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event) => event instanceof NavigationEnd),
        tap(() => {
          this.navigationEnd$.next();

          // const url = this.router.url;
          // const path = url?.split("?")?.[0];
          // this.routerRaw$.next({ url, path });

          // /**
          //  * activedRoute从顶级路由开始，由路由配置决定
          //  * 路由配置中每有一个children，activedRoute就会有一个firstChild属性
          //  * 比如对于路径 /app/connected-accounts 来说，共有3个firstChild，分别对应路由配置中的:
          //  * "", "app", "channel_manuger"
          //  * 因此要获取/app/channel的相关数据，需要递归的获取：while (activedRoute.firstChild)
          //  *
          //  * Tip: firstChild与url字段不同，firstChild完全由路由配置决定，而url代表了当前路由的片段，如对于 /app/properties/detail 来说，共有3个firstChild：
          //  * "", "app", "properties/detail"，而url分别为：
          //  * [""], ["app"], ["properties", "detail"]
          //  */
          // let currentRoute = this.activatedRoute;
          // while (currentRoute.firstChild) {
          //   currentRoute = currentRoute.firstChild;
          // }

          // /**
          //  * activedRoute中有一个snapshot属性，代表本路由此刻的快照，该属性包含了一系列实用的值，可从此属性中获取需要的数据
          //  */
          // const data = currentRoute.snapshot.data;
          // const url = this.router.url;
          // const path = _.head(_.split(url, "?"));

          // //#region i18nkeyRouter
          // /**
          //  * @deprecated on 4.11 ; breadcrumb.service.ts替换改服务
          //  */
          // // data.i18nkey = data.i18nkey ? this.i18nKeyPrefix + _.replace(data.i18nkey, this.i18nKeyPrefix, "") : "";
          // //#endregion

          // log("|current router| => [url]: ", url, " [path]: ", path, " [data]: ", data);

          // this.updateBreadcrumbs(currentRoute, url);

          // this.routerRaw$.next({ url, path, data });
        }),
      )
      .subscribe();
  }

  // /** @@deprecated */
  // updateBreadcrumbs(route: ActivatedRoute, url: string) {
  //   const child: ActivatedRoute = route;
  //   if (child.outlet === "primary") {
  //     const parent = _.get(child.snapshot.url[0], "path");

  //     const data = child.snapshot.data || {};
  //     const path: string = _.head(_.split(url, "?"));
  //     const params = child.snapshot.queryParams;
  //     const { name, level = 1, module, i18nkey } = data;
  //     const breadcrumb = { path, params, name, parent, level, module, i18nkey };

  //     const filtered = _.filter(this.breadcrumbs);
  //     let breadcrumbs = [].concat(this.breadcrumbs);
  //     if (_.isEmpty(filtered)) {
  //       breadcrumbs[level] = breadcrumb;
  //     } else {
  //       if (_.head(filtered).module !== module) {
  //         /** 不是同一个模块 */
  //         breadcrumbs = [];
  //         breadcrumbs[level] = breadcrumb;
  //       } else {
  //         /**
  //          * 同一个模块
  //          * 1, A/B/C  此时进入A,则只保留A
  //          * 2, A/B/C  此时进入B,则保留A/B
  //          * 3, B/C    此时进入A,则只保留A
  //          */

  //         if (level < _.last(filtered).level) {
  //           if (_.find(breadcrumb, "level")) {
  //             breadcrumbs = breadcrumbs.slice(0, level + 1);
  //           } else {
  //             breadcrumbs = [];
  //             breadcrumbs[level] = breadcrumb;
  //           }
  //         } else {
  //           breadcrumbs[level] = breadcrumb;
  //         }
  //       }
  //     }

  //     this.set(breadcrumbs);
  //     log("|current router| => [breadcrumbs]: ", this.breadcrumbs);
  //   }
  // }

  // /**
  //  * 根据url找到对应的breadcrumb，并合并option
  //  */
  // updateSingleBreadcrumb(url: string, option: Breadcrumb) {
  //   const path: string = _.head(_.split(url, "?"));
  //   const breadcrumbs: Array<Breadcrumb> = [].concat(this.breadcrumbs);
  //   console.log("breadcrumbs: ", breadcrumbs);
  //   const index = _.findIndex(breadcrumbs, { path });
  //   console.log("path: ", path, " index: ", index);
  //   if (index !== -1) {
  //     let breadcrumb = breadcrumbs[index];
  //     breadcrumb = { ...breadcrumb, ...option };
  //     breadcrumbs.splice(index, 1, breadcrumb);
  //     this.set(breadcrumbs);
  //   }
  // }

  // set(value) {
  //   this.breadcrumbRaw$.next(value);
  // }

  // destroy() {
  //   console.log("index destroy");
  //   this.destroy$.next(null);
  //   this.destroy$.complete();
  // }
}
